import React, { useMemo, useState, useEffect, useRef } from "react";
import columns from "./TelevisiteColumns";
import PageTitle from "../../components/PageTitle/PageTitle";
import {
  Assignment as AssignmentIcon,
  Delete as DeleteIcon,
  Edit as EditIcon,
} from "@mui/icons-material";
import {
  Paper,
  Box,
  Button,
  MenuItem,
  IconButton,
  Snackbar,
  Alert,
  Dialog,
  Typography,
} from "@mui/material";
import { useAuthHeader, useAuthUser } from "react-auth-kit";
import {
  AddTelevisit,
  ViewTelevisit,
  useDeleteTelevisit,
  useGetTelevisits,
  usePutTelevisit,
} from "../../components/TelevisitComponents";
import {
  LoadingError,
  LoadingPaper,
  EmptyPaper,
} from "../../components/LoadingComponents";
import MaterialReactTable from "material-react-table";
import { useGetPatients } from "../../components/PatientComponents";
import { useEditMode } from "../../components/EditableComponents";
import getColumns from "./TelevisiteColumns";

function Televisite(props) {
  // === authentication ===
  const authUser = useAuthUser();

  // === web service queries/mutations ===
  const patientsQuery = useGetPatients();
  const televisitsQuery = useGetTelevisits();
  const deleteMutation = useDeleteTelevisit();

  // === AddTelevisit modal handling ===
  const [openAddTelevisit, setOpenAddTelevisit] = useState(false);
  const _editMode = useRef(false);

  const [selectedTelevisit, setSelectedTelevisit] = useState(null);
  const editModeTelevisitMutation = usePutTelevisit(selectedTelevisit);
  const handleOpenAddTelevisit = () => {
    setOpenAddTelevisit(true);
  };
  const handleCloseAddTelevisit = () => {
    setOpenAddTelevisit(false);
  };

  // === EditMode handling ===
  const {
    editMode,
    enterEditMode,
    cancelEditMode,
    confirmEditMode,
    updateEditState,
    setQueryKey,
  } = useEditMode({
    editModeEnabled: _editMode.current,
    updateMutation: editModeTelevisitMutation,
    initialQueryKey: ["televisits", selectedTelevisit],
  });

  const tableColumns = getColumns(editMode, updateEditState);
  const userRole = authUser()?.role;

  return (
    <main style={{ width: "100%" }}>
      <Dialog open={openAddTelevisit}>
        <AddTelevisit closeModal={handleCloseAddTelevisit} />
      </Dialog>

      <PageTitle title="Televisite" />
      <Paper
        style={{ minHeight: "fitContent", margin: "3vh", maxWidth: "96%" }}
      >
        <Box>
          <Button
            style={{ margin: "15px" }}
            color="primary"
            onClick={handleOpenAddTelevisit}
            variant="contained"
          >
            NUOVA TELEVISITA
          </Button>
        </Box>

        {televisitsQuery.isLoading || patientsQuery.isLoading ? (
          <LoadingPaper />
        ) : televisitsQuery.isError || patientsQuery.isError ? (
          <LoadingError error={televisitsQuery.error} />
        ) : televisitsQuery.isSuccess &&
          televisitsQuery.data.televisits.length === 0 ? (
          <EmptyPaper message={"Nessuna televisita in programma"} />
        ) : (
          <MaterialReactTable
            columns={tableColumns}
            data={
              televisitsQuery.data?.televisits.map((el) => {
                return { ...el };
              }) || []
            }
            initialState={{
              density: "compact",
              showColumnFilters: true,
              columnVisibility: {
                professionista_sanitario: userRole !== 3,
              },
            }}
            enablePagination={true}
            enableBottomToolbar={true}
            enableTopToolbar={false}
            enableSorting={true}
            muiTablePaperProps={{
              elevation: 0,
            }}
            enableColumnResizing
            enableColumnActions={false}
            enableRowSelection={false}
            enableRowActions={true}
            displayColumnDefOptions={{
              "mrt-row-actions": { header: "Azioni" },
            }}
            positionActionsColumn="last"
            renderRowActionMenuItems={({ closeMenu, row }) => [
              <MenuItem
                key="edit"
                color={editMode ? "success" : "warning"}
                onClick={() => {
                  const televisitId = row.original.id;
                  setSelectedTelevisit(televisitId);
                  setQueryKey(["televisits", televisitId]);
                  if (editMode) confirmEditMode();
                  else enterEditMode(televisitId);
                }}
              >
                <IconButton>
                  {" "}
                  <EditIcon color={editMode ? "success" : "warning"} />
                </IconButton>
                {editMode ? "Conferma modifiche" : "Modifica televisita"}
              </MenuItem>,
              userRole !== 3 ? (
                <MenuItem
                  key="delete"
                  onClick={() => {
                    deleteMutation.mutate(row.original.id);
                    closeMenu();
                  }}
                >
                  <IconButton>
                    <DeleteIcon color="error" />
                  </IconButton>
                  Rimuovi televisita
                </MenuItem>
              ) : null,
              <MenuItem key="report" onClick={() => console.log("report")}>
                <IconButton>
                  {" "}
                  <AssignmentIcon color="primary" />
                </IconButton>{" "}
                Scarica report
              </MenuItem>,
            ]}
            renderDetailPanel={({ row }) => {
              return (
                <ViewTelevisit
                  editMode={editMode}
                  updateEditState={updateEditState}
                  televisit_id={row.original.id}
                />
              );
            }}
          />
        )}
      </Paper>
    </main>
  );
}

export default Televisite;
